export default "__VITE_ASSET__BHWIDQ72__"